import React = require('react');
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {User} from "../../models/User";
import UsersService from "../../services/UsersService";
import {ReactNode} from "react";

export interface PermissionContainerProps{
	hasPermission?: string;
	hasAnyPermission?: string[];
	hasAllPermissions?: string[];
	currentUser: User,
	children?: ReactNode
}

export interface PermissionContainerState{
}

function mapStateToProps(state: ApplicationState) {
	return {
		currentUser: state.global.currentUser
	};
}

class PermissionContainer extends React.Component<PermissionContainerProps, PermissionContainerState>{

	constructor(props: PermissionContainerProps) {
		super(props)
	}

	componentDidMount() {
		// logger.logBox = this;
	}

	render(): React.ReactNode {
		var p = this.props,
			currentUser = p.currentUser
		if (!currentUser) return null
		if(currentUser.isAdmin
			|| (p.hasPermission != null && UsersService.hasPermission(currentUser, p.hasPermission))
			|| (p.hasAnyPermission != null && UsersService.hasAnyPermission(currentUser, p.hasAnyPermission))
			|| (p.hasAllPermissions != null && UsersService.hasAllPermissions(currentUser, p.hasAllPermissions))
		){
			return this.props.children
		}
		return null;
	}
}

export default connect(mapStateToProps)(PermissionContainer)
